<template>
    <div class="register-container">
        <div class="banner-wrap">
            <el-carousel height="100vh">
                <el-carousel-item :key="item" v-for="item in bannerList">
                    <el-image :src="require(`@/assets/image/login/${item}`)" fit="contain"></el-image>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="register-wrap">
            <div class="register-box">
                <el-steps :active="active">
                    <el-step title="Step 1"></el-step>
                    <el-step title="Step 2"></el-step>
                    <el-step title="Step 3"></el-step>
                </el-steps>
                <div class="step1" v-show="![2, 3].includes(active)">
                    <p class="register-title">
                        <el-button class="sign-in-btn" type="text" @click="$router.push({ path: '/login' })">Sign in
                        </el-button>Create a new account
                    </p>
                    <el-scrollbar :style="{
                        height: screenResolution === '16x9' ? '65vh' : '',
                    }">
                        <el-form ref="registerForm" :rules="rules" :model="registerForm" size="small" :style="{
                            paddingRight:
                                screenResolution === '16x9' ? '20px' : '',
                        }" @keydown.enter.native.prevent>
                            <el-form-item :label="`${$t('register.firstName')}`" prop="firstName">
                                <el-input v-model="registerForm.firstName"></el-input>
                            </el-form-item>
                            <el-form-item :label="`${$t('register.lastName')}`" prop="lastName">
                                <el-input v-model="registerForm.lastName"></el-input>
                            </el-form-item>
                            <el-form-item :label="`${$t('register.email')}`" prop="email">
                                <el-input v-model="registerForm.email"></el-input>
                            </el-form-item>
                            <el-form-item :label="`${$t('register.mobile')}`" prop="mobile">
                                <el-input v-model="registerForm.mobile"></el-input>
                            </el-form-item>
                            <el-form-item :label="`${$t('register.country')}`" prop="country">
                                <el-select v-model="registerForm.country" :placeholder="`${$t(
                                    'register.selectPlaceholder'
                                )}`" filterable>
                                    <el-option v-for="c in countryList" :key="c.name_en" :label="c.name_en" :value="c.name_en">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="`${$t('register.company')}`" prop="company">
                                <el-input v-model="registerForm.company"></el-input>
                            </el-form-item>
                            <el-form-item :label="`${$t('register.invitationCode')}`" prop="business_code">
                                <el-input v-model="registerForm.business_code"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button class="register-btn" :loading="step1Loading"
                                    @click="register('registerForm')" v-ga="{
                                        eventCategory: 'engagement',
                                        eventAction: 'signup_start',
                                        eventLabel: 'method',
                                    }">Create now</el-button>
                            </el-form-item>
                        </el-form>
                    </el-scrollbar>
                    <div class="privacy-policy-div">
                        <span>By creating the account, I agree to cmoffer's</span>
                        <span class="text-underline">Terms & Conditions, </span>
                        <span class="text-underline">
                            Privacy Policy Cancellation.
                        </span>
                    </div>
                </div>
                <div class="step2" v-show="active == 2">
                    <p class="register-title">Verify email</p>
                    <p class="register-tip">
                        Please open your registration email to get the
                        verification code and enter it
                    </p>
                    <el-form ref="verifyForm" :model="verifyForm" size="small" @keydown.enter.native.prevent>
                        <el-form-item :label="`${$t('register.verificationCode')}`" prop="code" :rules="[
                            {
                                required: true,
                                message: `${$t(
                                    'register.inputPlaceholder'
                                )}`,
                                trigger: 'blur',
                            },
                            {
                                pattern: /^[0-9]{6}$/,
                                message: `${$t(
                                    'register.value6digitsRequired'
                                )}`,
                            },
                        ]">
                            <el-input maxlength="6" v-model="verifyForm.code"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button :class="['register-btn']" :loading="step2Loading" @click="verify('verifyForm')"
                                v-ga="{
                                    eventCategory: 'engagement',
                                    eventAction: 'signup_verify',
                                    eventLabel: 'method',
                                }">Verification</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="step3" v-show="active == 3">
                    <div v-if="verificationResults">
                        <p class="register-title">Congratulations</p>
                        <!-- 验证成功 -->
                        <div class="verification-results">
                            <i class="el-icon-success"></i>
                            <span>Register succeeded, please
                                <el-link type="primary" @click="signIn" style="font-size: 17px">login</el-link>
                            </span>
                        </div>
                        <!-- 验证失败 -->
                        <!-- <div class="verification-results" v-else>
                        <i class="el-icon-error"></i>
                        <span>Verification error, please again verify.</span>
                    </div>
                    <el-button
                        :class="['register-btn', { disabled: disabled }]"
                        :disabled="disabled"
                        @click="signIn"
                        >{{ disabled ? "Loading..." : "Sign in" }}</el-button
                    > -->
                    </div>
                    <div v-else>
                        <p class="register-title">Set password</p>
                        <p class="register-tip">
                            Please set your login password
                        </p>
                        <el-form ref="createForm" size="small" :model="createForm" :rules="createFormRules" @keydown.enter.native.prevent>
                            <el-form-item :label="`${$t('register.password')}`" prop="password">
                                <el-input type="password" v-model="createForm.password" @input="checkCreatable"
                                    show-password></el-input>
                            </el-form-item>
                            <el-form-item :label="`${$t('register.repeatpassword')}`" prop="repeatPassword">
                                <el-input type="password" v-model="createForm.repeatPassword" @input="checkCreatable"
                                    show-password></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-alert v-if="registerError" :title="registerError" type="error" show-icon
                                    :closable="false" style="margin-bottom: 10px">
                                </el-alert>
                            </el-form-item>
                            <el-form-item>
                                <el-button class="register-btn" :loading="step3Loading" @click="create('createForm')"
                                    v-ga="{
                                        eventCategory: 'engagement',
                                        eventAction: 'signup_create',
                                        eventLabel: 'method',
                                    }">Create account</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import util from "@/utils/util.js";
import Axios from "axios";
import { mapState } from "vuex";
export default {
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("Please input"));
            } else if (value !== this.createForm.password) {
                callback(new Error("The two passwords are inconsistent!"));
            } else {
                callback();
            }
        };
        var validateEmail = (rule, value, callback) => {
            if (!util.isEmail(value)) {
                callback(new Error("Incorrect email format"));
            } else {
                callback();
            }
        };
        return {
            active: 0,
            bannerList: ["banner-1.jpg", "banner-2.jpg"],
            disabled: false,
            registerForm: {
                firstName: "",
                lastName: "",
                email: "",
                mobile: "",
                country: "",
                company: "",
                business_code: "",
            },
            verifyForm: {
                code: "",
            },
            createForm: {
                password: "",
                repeatPassword: "",
            },
            registerable: false,
            verifiable: false,
            creatable: false,
            rules: {
                firstName: [
                    {
                        required: true,
                        message: this.$t("register.inputPlaceholder"),
                        trigger: "blur",
                    },
                    {
                        min: 2,
                        message: this.$t("register.atLeast2Words"),
                        trigger: "blur",
                    },
                    {
                        pattern: /^[a-z0-9]+$/i,
                        message: this.$t("register.onlyEnDigit"),
                        trigger: "blur",
                    },
                ],
                lastName: [
                    {
                        required: true,
                        message: this.$t("register.inputPlaceholder"),
                        trigger: "blur",
                    },
                    {
                        min: 2,
                        message: this.$t("register.atLeast2Words"),
                        trigger: "blur",
                    },
                    {
                        pattern: /^[a-z0-9]+$/i,
                        message: this.$t("register.onlyEnDigit"),
                        trigger: "blur",
                    },
                ],
                email: [
                    {
                        required: true,
                        message: this.$t("register.inputPlaceholder"),
                        trigger: "blur",
                    },
                    { validator: validateEmail, trigger: "blur" },
                ],
                // mobile: [
                //     {
                //         required: true,
                //         message: this.$t("register.inputPlaceholder"),
                //         trigger: "blur",
                //     },
                // ],
                country: [
                    {
                        required: true,
                        message: this.$t("register.selectPlaceholder"),
                        trigger: "change",
                    },
                ],
                company: [
                    {
                        required: true,
                        message: this.$t("register.inputPlaceholder"),
                        trigger: "blur",
                    },
                ],
            },
            createFormRules: {
                password: [
                    {
                        required: true,
                        message: `${this.$t("register.inputPlaceholder")}`,
                        trigger: "blur",
                    },
                    {
                        min: 6,
                        message: `${this.$t("register.atLeast6Chars")}`,
                    },
                    {
                        max: 20,
                        message: `${this.$t("register.maximum20Chars")}`,
                    },
                ],
                repeatPassword: [
                    {
                        required: true,
                        validator: validatePass,
                        trigger: "blur",
                    },
                    {
                        min: 6,
                        message: `${this.$t("register.atLeast6Chars")}`,
                    },
                    {
                        max: 20,
                        message: `${this.$t("register.maximum20Chars")}`,
                    },
                ],
            },
            verificationResults: false,
            countryList: [],
            registerError: "",
            step1Loading: false,
            step2Loading: false,
            step3Loading: false,
        };
    },
    created() {
        this.$ga.event("engagement", "signup_visit");
        // Axios.get("https://gz.cdn.loratech.cn/country-code.json").then(
        //     (res) => {
        //         this.countryList = res.data;
        //     }
        // );
        cmofferApi
            .countrySelect(
                {},"get"
            )
            .then((res) => {
                if (res) {
                    this.countryList = res.data;
                }
            })
            .catch(() => {
            });
    },
    mounted() { },
    computed: {
        ...mapState({
            screenResolution: (state) => state.index.screenResolution,
        }),
    },
    methods: {
        checkRegisterable() {
            this.registerable =
                this.registerForm.firstName !== "" &&
                this.registerForm.lastName !== "" &&
                util.isEmail(this.registerForm.email) &&
                this.registerForm.country !== "" &&
                this.registerForm.company !== "";
        },
        checkCreatable() {
            let len = this.createForm.password.length;
            // console.log(len);
            this.creatable =
                /^[0-9]{6}$/.test(this.verifyForm.code) &&
                len >= 6 &&
                len <= 20 &&
                this.createForm.password === this.createForm.repeatPassword;
        },
        signIn() {
            this.$router.push({
                path: "/login",
            });
        },
        toStep(res, index) {
            res &&
                ((res.errcode === 0 && (this.active = index)) ||
                    this.$message.error(res.errmsg));
        },
        register(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.step1Loading = true;
                    cmofferApi
                        .register(this.registerForm, "put")
                        .then((res) => {
                            this.step1Loading = false;
                            this.$message.success(
                                "Please also check your spam or junk mail folder."
                            );
                            this.toStep(res, 2);
                        });
                }
            });
        },
        verify(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.step2Loading = true;
                    cmofferApi
                        .verifyEmailCode(
                            {
                                ...this.verifyForm,
                                email: this.registerForm.email,
                            },
                            "post"
                        )
                        .then((res) => {
                            this.step2Loading = false;
                            this.toStep(res, 3);
                        });
                }
            });
        },
        create(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.step3Loading = true;
                    cmofferApi
                        .createUser(
                            {
                                ...this.createForm,
                                code: this.verifyForm.code,
                                email: this.registerForm.email,
                            },
                            "put"
                        )
                        .then((res) => {
                            this.step3Loading = false;
                            this.$ga.event(
                                "engagement",
                                "signup_congrat",
                            );
                            if (res) {
                                if (res.errcode === 0) {
                                    this.verificationResults = true;
                                    sessionStorage.removeItem("token_ptk");
                                    res.platform && res.store && (sessionStorage.setItem('authTip', `${res.platform}-${res.store}`));
                                 } else {
                                    this.registerError = res.errmsg;
                                 }
                            }
                        });
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.register-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    position: relative;

    .banner-wrap {
        flex: 0 1 550px;
        background: #373330;
        transition: all 0.6s;

        ::v-deep .el-carousel {
            .el-carousel__item {
                &:nth-child(odd) {
                    background: #d3dce6;
                }

                &:nth-child(even) {
                    background: #99a9bf;
                }
            }

            .el-carousel__arrow {
                display: none;
            }

            .el-carousel__indicators--horizontal {
                bottom: 50px;

                .el-carousel__indicator--horizontal {
                    .el-carousel__button {
                        width: 22px;
                        height: 7px;
                        border-radius: 4px;
                    }
                }

                .is-active {
                    .el-carousel__button {
                        width: 44px;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 900px) {
        .banner-wrap {
            flex: 0 1 0;
        }
    }

    .register-wrap {
        flex: 1 1 auto;
        background: #ffffff;
        position: relative;
        text-align: left;

        ::v-deep .register-box {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            // min-width: 490px;
            width: 510px;
            min-height: 480px;
            padding: 10px;
            color: $color-000000a6;
            box-sizing: border-box;

            .el-steps {
                margin-bottom: 30px;

                .is-finish {
                    color: $color-primary;
                    border-color: $color-primary;
                }
            }

            .el-form-item--small {
                .el-form-item__content {

                    .el-select,
                    .el-select--small {
                        width: 100%;
                    }
                }

                .el-form-item__label {
                    font-size: 14px;
                    font-weight: 600;

                    &::before {
                        content: "";
                        margin-right: 0px;
                    }
                }

                &.is-required {
                    .el-form-item__label {
                        &::after {
                            content: "*";
                            color: #f56c6c;
                            margin-left: 4px;
                        }
                    }
                }

                &:last-child {
                    margin-bottom: 0 !important;
                }
            }

            .register-title {
                font-size: 26px;
                font-weight: 600;
                margin-bottom: 40px;
                color: #1c2d42;

                .sign-in-btn {
                    float: right;
                    color: $color-000000a6;
                    text-decoration: underline;
                }
            }

            .register-tip {
                font-size: 14px;
                margin-bottom: 15px;
            }

            .register-btn {
                color: #fff;
                min-height: 50px;
                line-height: 50px;
                margin: 25px 0 15px;
                cursor: pointer;
                background: $color-primary;
                width: 100%;
                padding: 0;
                border-radius: 0.015rem;
                border: none;
                outline: none;
                font-size: 18px;

                &:hover {
                    color: rgb(240, 240, 240);
                }

                &.is-disabled {
                    opacity: 0.7;
                    cursor: no-drop;
                }
            }

            .privacy-policy-div {
                margin: 0 0 30px 0;
                color: #aaaaaa;
                font-size: 13px;
                line-height: 25px;

                span:first-child {
                    margin-right: 5px;
                }

                .text-underline {
                    font-size: 13px;
                    text-decoration: underline;
                }
            }

            .verification-results {
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 90px 0 50px;

                i {
                    font-size: 30px;
                    margin-right: 8px;
                }

                .el-icon-success {
                    color: $color-primary;
                }

                .el-icon-error {
                    color: #f56c6c;
                }

                span {
                    font-size: 17px;
                }
            }

            .el-alert__content {
                padding: 0 0 0 8px;
            }

            .el-scrollbar {
                .el-scrollbar__wrap {
                    overflow-x: hidden !important;
                }
            }
        }
    }
}
</style>
